<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import store from "./store";

  export default {
    name: 'App',
    created() {

    },
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue